<div class="container-fluid mt-3">
  <div class="col-12">
    <mat-checkbox [checked]="paymentAndUploadMode === 1" (change)="onCheck(1)" class="mailingAddress">I will pay the
      registration fee online and upload the required documentation</mat-checkbox>
  </div>
  <div class="col-12">
    <mat-checkbox [checked]="paymentAndUploadMode === 2" (change)="onCheck(2)" class="mailingAddress">I will mail in my
      payment for registration fees but upload the required documentation</mat-checkbox>
  </div>
  <div class="col-12">
    <mat-checkbox [checked]="paymentAndUploadMode === 3" (change)="onCheck(3)" class="mailingAddress">I will mail in my
      registration fees and all required documentation</mat-checkbox>
  </div>
  <div class="bottom-line"></div>
  <div class="row">
    <h4 fxLayout="row" fxLayoutAlign="center center">Upload file types are restricted to PDF, JPG, and PNG
    </h4>
  </div>
  <div class="row mt-2">
    <div class="col-lg-2"></div>
    <div class="col-lg-8 col-md-12">
      <input fxLayout="row" id="uploadFileInput" aria-label="Please upload a file" fxLayoutAlign="center center" accept=".png,.pdf,.jpg" type="file" class="file-upload"
        (change)="onFileSelected($event)" #fileUpload>
    </div>
    <div class="col-lg-2"></div>
  </div>
  <div class="row mt-2">
    <div class="col-lg-2"></div>
    <div class="col-lg-5 col-md-12">
      <mat-progress-bar class="progress-bar" *ngIf="progress" mode="determinate" [value]="progress">
      </mat-progress-bar>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-lg-2"></div>
    <div class="col-lg-5 col-md-12">
      <mat-form-field>
        <mat-label>Select all that apply</mat-label>
        <mat-select [formControl]="doctypeControl" multiple>

          <mat-select-trigger>
            <mat-chip-list>
              <mat-chip *ngFor="let doctype of doctypeControl.value" [removable]="true"
                (removed)="onDocRemoved(doctype)">
                {{ doctype.description }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-select-trigger>
          <mat-option *ngFor="let doctype of docTypeList" [value]="doctype">{{doctype?.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-lg-5">
      <button mat-raised-button class="" color="primary" [disabled]="!(file && doctypeControl.value.length >0)"
        (click)="onSave()">Continue</button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-lg-2"></div>
    <div class="col-lg-8 col-md-12 applicant-background-color">
      <span fxLayout="row" fxLayoutAlign="center center" class='applicant-span'>Registration Control # Documents</span>
    </div>
    <div class="col-lg-2"></div>
  </div>
  <div class="row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8 col-md-12 ">
      <table mat-table [dataSource]="dataSource" matSort #sort="matSort" class="mat-elevation-z8 doctable">
        <ng-container matColumnDef="fileName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>File Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.originalFileName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="documentTypes">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Document Type(s)</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </table>
    </div>
  </div>
</div>
